import React from 'react';
import { RentXTransfer } from './RentXTransfer';

const rentXTransferRoutes = [
  {
    props: {
      exact: true,
      path: `/menu/outlet-app/outlet-setting/:outletID/rentx-transfer`,
    },
    component: <RentXTransfer />,
  },
];

export default rentXTransferRoutes;

